export default {
  load_config: { method: 'get', url: 'api/clients/config' },
  show: { method: 'get', url: 'api/clients{/id}' },
  update: { method: 'post', url: 'api/clients{/id}' },
  data_home: { method: 'get', url: 'api/clients/home' },
  actions: { method: 'get', url: 'api/clients/actions' },
  responsibles: { method: 'get', url: 'api/clients/responsibles' },
}
